import React from 'react';
import ReactDOM from 'react-dom/client';
import ChatProvider from './assets/context';
import "./index.css";
import App from './App';
import {BrowserRouter} from "react-router-dom"
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <ChatProvider>

    <App />
    </ChatProvider>
  </BrowserRouter>  
);


